/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerFindOneQueryResponse, TemplateQuestionsControllerFindOnePathParams, TemplateQuestionsControllerFindOneQueryParams, TemplateQuestionsControllerFindOne400, TemplateQuestionsControllerFindOne401, TemplateQuestionsControllerFindOne403, TemplateQuestionsControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionsControllerFindOne";

function getTemplateQuestionsControllerFindOneUrl(id: TemplateQuestionsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-template-questions/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist template question by ID
 * {@link /api/v1/checklist-template-questions/:id}
 */
export async function templateQuestionsControllerFindOne(id: TemplateQuestionsControllerFindOnePathParams["id"], params?: TemplateQuestionsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindOne400 | TemplateQuestionsControllerFindOne401 | TemplateQuestionsControllerFindOne403 | TemplateQuestionsControllerFindOne404>, unknown>({ method : "GET", url : getTemplateQuestionsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}